import { AbstractPopUp } from './AbstractPopUp';
import { createButton, createSprite, translate } from '../utils/GameEngine';
import Sprite = PIXI.Sprite;
import Text = PIXI.Text;
import { TextStyles } from '../utils/TextStyles';
import { SwitchButton } from '../UI/elements/buttons/SwitchButton';
import { SettingState, SettingsManager } from '../core/managers/SettingsManager';
import { Button } from '../UI/elements/buttons/Button';
import { Events } from '../core/Events';
import { GameAnalytics } from '../analytics/GameAnalytics';

export class SettingsPopUp extends AbstractPopUp {
    private sfxButton: SwitchButton;
    private musicButton: SwitchButton;
    private vibrButton: SwitchButton;

    protected drawBackground(): void {
        super.drawBackground();

        const iconsX: number = this.textBox.x + 10;
        const labelsX: number = this.textBox.x + 60;
        const buttonsX: number = labelsX + 240;

        const sfxY: number = 166;
        const musicY: number = 246;
        const vibrY: number = 326;

        const sfxIcon: Sprite = createSprite('sfx_icon', this);
        sfxIcon.visible = false;
        const musicIcon: Sprite = createSprite('music-icon', this);
        const vibrIcon: Sprite = createSprite('vibration-icon', this);
        sfxIcon.anchor.set(0.5, 0.5);
        musicIcon.anchor.set(0.5, 0.5);
        vibrIcon.anchor.set(0.5, 0.5);
        sfxIcon.position.set(iconsX, sfxY);
        musicIcon.position.set(iconsX, musicY);
        vibrIcon.position.set(iconsX, vibrY);

        const sfxLabel: Text = new PIXI.Text(translate('Sounds', true), TextStyles.uiTextWhite);
        const musicLabel: Text = new PIXI.Text(translate('Music', true), TextStyles.uiTextWhite);
        const vibrLabel: Text = new PIXI.Text(translate('Vibration', true), TextStyles.uiTextWhite);
        sfxLabel.anchor.set(0, 0.5);
        musicLabel.anchor.set(0, 0.5);
        vibrLabel.anchor.set(0, 0.5);
        // this.addChild(sfxLabel);
        this.addChild(musicLabel);
        this.addChild(vibrLabel);
        sfxLabel.position.set(labelsX, sfxY - 5);
        musicLabel.position.set(labelsX, musicY - 5);
        vibrLabel.position.set(labelsX, vibrY - 5);

        const settingsSFX: SettingState = SettingsManager.getInstance().getSettingsSFX();
        const settingsMusic: SettingState = SettingsManager.getInstance().getSettingsMusic();
        const settingsVibrate: SettingState = SettingsManager.getInstance().getSettingsVibrate();

        this.sfxButton = new SwitchButton(this.soundsOn, this.soundsOff, settingsSFX);
        this.musicButton = new SwitchButton(this.musicOn, this.musicOff, settingsMusic);
        this.vibrButton = new SwitchButton(this.vibrationOn, this.vibrationOff, settingsVibrate);
        // this.addChild(this.sfxButton);
        this.addChild(this.musicButton);
        this.addChild(this.vibrButton);
        this.sfxButton.position.set(buttonsX, sfxY);
        this.musicButton.position.set(buttonsX, musicY);
        this.vibrButton.position.set(buttonsX, vibrY);

        // const resetDataButton: Button = createButton('red_button_medium', this, () => {
        //     dispatchEvent(new CustomEvent(Events.resetProgressData));
        // }, 'Reset Progress', true, true, 0.7);
        // resetDataButton.position.set(this.background.width / 2, this.vibrButton.y + 60);
        //
        // if (GameAnalytics.getInstance().isTester()) {
        //     const purgeButton: Button = createButton('red_button_medium', this, () => {
        //         // StoryProgressManager.getInstance().purgeData();
        //     }, 'PURGE', true, true, 0.7);
        //     purgeButton.position.set(this.background.width / 2, 400);
        // }
    }

    private soundsOn(): void {
        SettingsManager.getInstance().setSettingsSFX(SettingState.On);
    }

    private soundsOff(): void {
        SettingsManager.getInstance().setSettingsSFX(SettingState.Off);
    }

    private musicOn(): void {
        SettingsManager.getInstance().setSettingsMusic(SettingState.On);
    }

    private musicOff(): void {
        SettingsManager.getInstance().setSettingsMusic(SettingState.Off);
    }

    private vibrationOn(): void {
        SettingsManager.getInstance().setSettingsVibrate(SettingState.On);
    }

    private vibrationOff(): void {
        SettingsManager.getInstance().setSettingsVibrate(SettingState.Off);
    }
}